function wrandom(items, weights) {
  let i;

  for (i = 1; i < weights.length; i++) {
    weights[i] += weights[i - 1];
  }

  const random = Math.random() * weights[weights.length - 1];

  for (i = 0; i < weights.length; i++) {
    if (weights[i] > random) {
      break;
    }
  }

  return items[i];
}

function sendBannerEvent(banner, eventName) {
  const img = banner.querySelector("img");
  const position =
    window.krimiBannerPositions[banner.parentNode.parentNode.dataset.pos || banner.parentNode.dataset.pos];
  window.dataLayer.push({
    event: eventName,
    eventCategory: "page_adverts",
    eventAction: eventName.replace("banner_", ""),
    link: banner.href,
    image: img.src,
    position: position,
    advertiser: banner.dataset.advertiser,
  });
}

function sendSponsorEvent(box, pageType, eventName) {
  window.dataLayer.push({
    event: eventName,
    eventCategory: `sponsors_${pageType}_banners`,
    eventAction: eventName.replace("banner_", ""),
    link: box.href,
    advertiser: box.dataset.advertiser,
  });
}

function sendAdvertEvent(advert, eventName) {
  window.dataLayer.push({
    event: eventName,
    eventCategory: "page_adverts",
    eventAction: eventName.replace("textadvert_", "").replace("jobadvert_", ""),
    link: advert.href,
    advertiser: advert.dataset.advertiser,
  });
}

function trackBannerView(banner) {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendBannerEvent(banner, "banner_show");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );

  observer.observe(banner);
}

function trackSponsorView(box, pageType) {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendSponsorEvent(box, pageType, "banner_show");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );

  observer.observe(box);
}

function trackAdvertView(link, eventPrefix) {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendAdvertEvent(link, `${eventPrefix}_show`);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.5,
    }
  );

  observer.observe(link);
}

function getBanner(position, advertiser) {
  if (!window.krimiBanners) {
    console.error("krimiBanners object is missing");
    return;
  }

  if (!window.krimiBanners[position]) {
    console.error(`banner position '${position}' not found`);
    return;
  }

  if (advertiser) {
    const banners = window.krimiBanners[position].filter((a) => a.id === advertiser)[0]["items"];
    return banners.sort(() => Math.random() - 0.5)[0];
  } else {
    const items = window.krimiBanners[position].map((o) => o.items);
    const weights = window.krimiBanners[position].map((o) => o.weight);
    const banners = wrandom(items, weights);
    return banners.sort(() => Math.random() - 0.5)[0];
  }
}

function fillBannerPosition(container) {
  const banner = getBanner(container.dataset.pos, container.dataset.advertiser);
  if (!banner) {
    console.error(`banner is missing: '${banner}'`);
    container.style.display = "none";
    return;
  }
  const linkEl = container.querySelector("a");
  linkEl.href = banner.link;
  linkEl.rel = "external nofollow";
  linkEl.dataset.advertiser = banner.title;
  const imageEl = linkEl.querySelector("img");
  imageEl.src = banner.image;
  imageEl.alt = banner.title;
  trackBannerView(linkEl);
  sendBannerEvent(linkEl, "banner_init");
  linkEl.addEventListener("click", () => sendBannerEvent(linkEl, "banner_click"));
}

function fillTextAdverts(container, items, eventPrefix) {
  items.forEach((ta) => {
    const a = document.createElement("a");
    a.innerHTML = ta.text;
    a.href = ta.link;
    a.dataset.advertiser = ta.advertiser;
    a.rel = "external";
    a.classList.add("sidebar-textadverts-link");
    container.appendChild(a);
    sendAdvertEvent(a, `${eventPrefix}_init`);
    trackAdvertView(a);
    a.addEventListener("click", () => sendAdvertEvent(linkEl, `${eventPrefix}_click`));
  });
}

document.addEventListener("DOMContentLoaded", function () {
  navigator.serviceWorker.register("/sw.js", {
    scope: "/",
  });
  NodeList.prototype.forEach = Array.prototype.forEach;
  HTMLCollection.prototype.forEach = Array.prototype.forEach;

  var param = "fbclid";
  if (location.search.indexOf(param + "=") !== -1) {
    var replace = "";
    try {
      var url = new URL(location);
      url.searchParams.delete(param);
      replace = url.pathname + url.search + url.hash;
    } catch (ex) {
      var regExp = new RegExp("[?&]" + param + "=.*$");
      replace = location.search.replace(regExp, "");
      replace = location.pathname + replace + location.hash;
    }
    history.replaceState(null, "", replace);
  }

  //if (document.cookie.indexOf("sessionid") < 0) {
  //  document.cookie = "krimi_csrf=; Max-age=0; Path=/; Domain=.krimi-plzen.cz; SameSite=Strict";
  //}

  if (typeof SVGUseElement !== "function") {
    document.querySelector(".site-logo img").style.display = "block";
  }

  const pageEl = document.querySelector(".page");
  const navEl = document.querySelector(".main-nav");

  document.querySelector(".sidebar-toggle").addEventListener("click", function () {
    if (pageEl.classList.contains("shifted")) {
      window.dataLayer.push({
        event: "sidebar_close",
        eventCategory: "page_navigation",
        eventAction: "close",
      });
    } else {
      window.dataLayer.push({
        event: "sidebar_open",
        eventCategory: "page_navigation",
        eventAction: "open",
      });
    }

    pageEl.classList.toggle("shifted");
    if (navEl.classList.contains("opened")) {
      navEl.classList.remove("opened");
    }
  });

  document.querySelector(".main-nav-toggle").addEventListener("click", function () {
    if (navEl.classList.contains("opened")) {
      window.dataLayer.push({
        event: "nav_close",
        eventCategory: "page_navigation",
        eventAction: "close",
      });
    } else {
      window.dataLayer.push({
        event: "nav_open",
        eventCategory: "page_navigation",
        eventAction: "open",
      });
    }

    navEl.classList.toggle("opened");
  });

  document.querySelectorAll(".partner-bοx").forEach((el) => fillBannerPosition(el));

  var lawAdviceForm = document.querySelector(".sidebar-lawadvice-form");
  if (lawAdviceForm !== null) {
    lawAdviceForm.addEventListener("submit", function (e) {
      var showLawAdviceNotification = function (text) {
        var el = document.querySelector(".sidebar-lawadvice-form-notification");
        el.innerText = text;
        el.classList.remove("hidden");
      };
      var getCookie = function (name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== "") {
          var cookies = document.cookie.split(";");
          for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === name + "=") {
              cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
              break;
            }
          }
        }
        return cookieValue;
      };
      e.preventDefault();
      var content = document.querySelector("#law-advice-content").value;
      var email = document.querySelector("#law-advice-email").value;
      var phone = document.querySelector("#law-advice-phone").value;
      if (content.length < 20 || email.length < 3 || phone.length < 8) {
        showLawAdviceNotification("Vyplňte prosím Váš dotaz a kontaktní údaje");
        return false;
      }
      fetch("/law/save/", {
        method: "POST",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "X-CSRFToken": getCookie("krimi_csrf"),
          "content-type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          phone: phone,
          content: content,
        }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (j) {
          showLawAdviceNotification(j.success ? j.message : "Chyba při odesílání: " + j.message);
          document.querySelector(".sidebar-lawadvice-form-buttons").classList.add("hidden");
        })
        .catch(function (err) {
          showLawAdviceNotification("Chyba při odesílání.");
        });
    });
  }

  const switchVideo = (videos, by) => {
    const currentVideo = [...document.querySelectorAll(".sidebar-videos-video video")].filter(
      (video) => video.parentNode.style.display === "block"
    )[0];
    currentVideo.pause();
    const index = [...videos].indexOf(currentVideo);
    const nextIndex = index + 1 + by;
    let nextVideo = currentVideo.parentNode.parentNode.children[nextIndex];
    if (!nextVideo || !nextVideo.classList.contains("sidebar-videos-video")) {
      if (by > 0) {
        nextVideo = videos[0].parentNode;
      } else {
        nextVideo = videos[videos.length - 1].parentNode;
      }
    }
    if (nextVideo !== currentVideo) {
      const vidEl = nextVideo.querySelector("video");
      vidEl.setAttribute("preload", "auto");
      vidEl.setAttribute("autoplay", true);
      currentVideo.parentNode.style.display = "none";
      nextVideo.style.display = "block";
      vidEl.play();
    }
  };

  const videos = document.querySelectorAll(".sidebar-videos-video video");
  if (videos.length > 0) {
    const chosenVid = videos[Math.floor(Math.random() * videos.length)];
    chosenVid.parentNode.style.display = "block";
    videos.forEach((video) => video.addEventListener("ended", () => switchVideo(videos, +1)));
    videos.forEach((video) =>
      video.addEventListener("play", () => {
        window.dataLayer.push({
          event: "video_play",
          eventCategory: "page_videos",
          eventAction: "play",
          article: video.nextElementSibling.href || video.children[0].src,
        });
      })
    );

    document.querySelector(".sidebar-videos button.prev").addEventListener("click", () => switchVideo(videos, -1));
    document.querySelector(".sidebar-videos button.next").addEventListener("click", () => switchVideo(videos, +1));
  }

  const slider = document.querySelector(".article-list-partner-slіder");
  const sidebarHidden = getComputedStyle(document.querySelector(".sidebar-toggle")).display === "block";

  if (slider && sidebarHidden) {
    const vidBefore = document.querySelector(".article-list-top-section").nextElementSibling;
    const vid = document.querySelector(".sidebar-videos");
    if (vid) {
      vid.style.marginTop = "2em";
      vidBefore.parentNode.insertBefore(vid, vidBefore);
    }
  }

  document.querySelectorAll(".sidebar-articles").forEach((div) =>
    div.querySelectorAll("a").forEach((a) => {
      if (a.getAttribute("href") == document.location.pathname) {
        div.removeChild(a);
      }
    })
  );

  document.querySelectorAll(".sidebar-articles.top-articles a").forEach((a, i) => {
    if (i > 4) {
      a.parentNode.removeChild(a);
    }
  });

//  document.querySelector(".main-nav a[href='/a/tag/inzerce']").href = "/a/inzerce-2024-01-19-185658/";

  if (window.krimiTextAdverts && window.krimiTextAdverts.length > 0) {
    const div = document.querySelector(".sidebar-textadverts.textadverts");
    const heading = document.createElement("h2");
    heading.innerText = "Řádková inzerce";
    div.appendChild(heading);
    const container = document.createElement("div");
    fillTextAdverts(container, window.krimiTextAdverts, "textadvert");
    div.appendChild(container);
  }

  if (window.krimiJobAdverts && window.krimiJobAdverts.length > 0) {
    const div = document.querySelector(".sidebar-textadverts.jobadverts");
    const heading = document.createElement("h2");
    heading.innerText = "Nabídka práce";
    div.appendChild(heading);
    const container = document.createElement("div");
    fillTextAdverts(container, window.krimiJobAdverts, "jobadvert");
    div.appendChild(container);
  }

  if (slider && sidebarHidden) {
    const taBefore = document.querySelector(".article-list-card:nth-child(13)");
    const ta = document.querySelector(".sidebar-textadverts.textadverts");
    if (taBefore && ta) {
      ta.style.marginBottom = "3em";
      taBefore.parentNode.insertBefore(ta, taBefore);
    }
    const jaBefore = document.querySelector(".article-list-card:nth-child(16)");
    const ja = document.querySelector(".sidebar-textadverts.jobadverts");
    if (jaBefore && ja) {
      ja.style.marginBottom = "3em";
      jaBefore.parentNode.insertBefore(ja, jaBefore);
    }
  }
});
